import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import apiUser from "../apiUser";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState({});
    const [token, setToken] = useState(null);
    const [signed, setSigned] = useState(false);
    // true enquanto a sessao persistida (cookie RT) esta sendo validada no refresh;
    // o Authenticator espera isso terminar antes de redirecionar para /login.
    const [validando, setValidando] = useState(true);
    const [alert, setAlert] = useState({ visible: false, title: "", placeholder: "", confirm: false, type: "none" });

    const COOKIE_DIAS = 7;
    const salvarCookie = (t) => { document.cookie = `RT=${t}; path=/; max-age=${COOKIE_DIAS * 86400}`; };
    const limparCookie = () => { document.cookie = `RT=; path=/; max-age=0`; };
    const getCookie = (name) => {
        const found = document.cookie.split('; ').find((c) => c.startsWith(`${name}=`));
        return found ? found.slice(name.length + 1) : null;
    };

    const validateToken = async () => {
        const pathName = window.location.pathname;
        const ehPublica = pathName.includes("openTable") || pathName.includes("senha")
            || pathName.includes("termos") || pathName.startsWith("/faturamento/");
        if (ehPublica) { setValidando(false); return; }

        const refreshToken = getCookie("RT");
        if (!refreshToken || signed) { setValidando(false); return; }

        try {
            apiUser.defaults.headers.common['authorization'] = `Bearer ${refreshToken}`;
            const response = await apiUser.post("/validate-token");
            const { success, token, id, nome, nivel } = response.data;
            if (success) {
                setSigned(true);
                setToken(token);
                setUser({ id, nome, nivel });
                apiUser.defaults.headers.common['authorization'] = `Bearer ${token}`;
                salvarCookie(token); // janela deslizante: renova a validade a cada visita
                // mantem o usuario na tela em que estava; so redireciona se veio de fora
                if (pathName === "/" || pathName === "/login") navigate("/home");
            } else {
                limparCookie();
                delete apiUser.defaults.headers.common['authorization'];
                setSigned(false);
            }
        } catch (error) {
            console.error("Error validating token:", error);
        } finally {
            setValidando(false);
        }
    };


    useEffect(() => {
        validateToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const signIn = async (email, senha) => {
        try {
            const response = await apiUser.post("/login", { email, senha });
            const { success, message, token, id, nome , nivel } = response.data;
            if (success) {
                setSigned(true);
                setUser({ id, nome, nivel});
                setToken(token);
                apiUser.defaults.headers.common['authorization'] = `Bearer ${token}`;
                salvarCookie(token);
                navigate("/home");
            } else {
                setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
            }
        } catch (error) {
            console.error("Erro no login:", error);
            setAlert({ visible: true, title: "Erro!", placeholder: "Erro ao fazer login. Tente novamente.", confirm: false, type: "negative" });
        }
    };

    const signOut = () => {
        setSigned(false);
        setUser({});
        setToken(null);
        limparCookie();
        delete apiUser.defaults.headers.common['authorization'];
        navigate("/login");
    };

    const esqueciSenha = async (email) => {
        try {
            const response = await apiUser.post("/esqueci-senha", { email });
            const { success, message } = response.data;
            if (success) {
                setAlert({ visible: true, title: "Sucesso!", placeholder: message, confirm: false, type: "success" });
            } else {
                setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
            }
        } catch (error) {
            console.error("Erro ao enviar e-mail de recuperação:", error);
            setAlert({ visible: true, title: "Erro!", placeholder: "Erro ao enviar e-mail de recuperação. Tente novamente.", confirm: false, type: "negative" });
        }
    };

    const alterarSenha = async (email, senha, hash) => {
        try {
            const response = await apiUser.post("/redefinir-senha", { email, senha, hash });
            const { success, message } = response.data;
            if (success) {
                setAlert({ visible: true, title: "Sucesso!", placeholder: message, confirm: false, type: "success" });
                navigate("/login");
            } else {
                setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
            }
        } catch (error) {
            console.error("Erro ao alterar senha:", error);
            setAlert({ visible: true, title: "Erro!", placeholder: "Erro ao alterar senha. Tente novamente.", confirm: false, type: "negative" });
        }
    };

    const nivel = user?.nivel ? String(user.nivel) : null;
    const isAdmin = nivel === '3';
    const isGerente = nivel === '2' || nivel === '3';

    return (
        <UserContext.Provider value={{
            signed,
            validando,
            user,
            alert,
            setAlert,
            token,
            signIn,
            signOut,
            esqueciSenha,
            alterarSenha,
            isAdmin,
            isGerente,
        }}>
            {children}
        </UserContext.Provider>
    );
};